<template>
  <v-layout v-if="monitor">
    <v-card
      elevation="10"
      class="mx-auto px-5"
      width="325"
      height="400"
      @click="viewMonitor(monitor.monitor_id)"
    >
      <v-card-subtitle class="preview-title">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-if="monitor.name && monitor.name.length > 0"
              v-bind="attrs"
              v-on="on"
              style="font-size: 22px"
              class="pr-1 text--primary"
              >{{ monitor.name }}</span
            >

            <span v-else style="font-size: 22px" class="pr-1 text--primary">{{
              monitor.monitor_id
            }}</span></template
          >
          <span>{{ monitor.name }}</span> </v-tooltip
        ><br />

        <span class="pr-1 text--secondary">{{ "Created By:" }}</span>
        {{ getUserDetails(monitor.account_id, monitor.user_id).name }} <br />

        <span class="pr-1 text--secondary">{{ "Created On:" }}</span>
        {{ new Date(monitor.created).toLocaleString() }}
      </v-card-subtitle>
      <br />

      <div style="min-height: 256px; min-width: 256px; height: 40%">
        <Map
          :min-zoom="3"
          :max-zoom="19"
          :polygons="getPolygon(monitor)"
          :bounds="getBounds(monitor)"
          :bounds-options="{ padding: 50 }"
          map-style="mapbox://styles/mapbox/dark-v10"
        />
      </div>
    </v-card>
  </v-layout>
</template>

<script>
import Map from "@/components/map/index";
import turfBbox from "@turf/bbox";
import turfBboxPoly from "@turf/bbox-polygon";
import Wkt from "wicket";
import { mapGetters } from "vuex";
import adminApi from "../../api/admin";
export default {
  props: ["monitor"],
  data() {
    return {
      user_promises: {},
      users: {},
    };
  },
  components: {
    Map,
  },
  computed: {
    ...mapGetters(["user_details", "account_details"]),
  },
  methods: {
    getPolygon(monitor) {
      if (monitor.intersects) {
        return [
          {
            type: "Feature",
            geometry: this.parseGeom(monitor.intersects),
          },
        ];
      } else if (monitor.bbox) {
        return [turfBboxPoly(monitor.bbox)];
      } else {
        return null;
      }
    },
    getBounds(monitor) {
      if (monitor.intersects) {
        return turfBbox({
          type: "Feature",
          geometry: this.parseGeom(monitor.intersects),
        });
      } else if (monitor.bbox) {
        return turfBbox(turfBboxPoly(monitor.bbox));
      } else {
        return null;
      }
    },
    parseGeom(geom) {
      if (typeof geom === "string") {
        var wkt = new Wkt.Wkt();
        wkt.read(geom);
        geom = wkt.toJson();
      }
      return geom;
    },
    getUserDetails(account_id, user_id) {
      if (!this.user_promises[user_id]) {
        // cache the promises so we're not making requests for the same user
        this.user_promises[user_id] = adminApi
          .get_user(account_id, user_id)
          .then((response) => {
            this.users[user_id] = response.data.user;
            // TODO: there's likely a better way
            this.$forceUpdate(); // things will likely have already rendered
          })
          .catch((error) => {
            return error;
          });
      }
      return this.users[user_id] || {};
    },
    viewMonitor(monitor_id) {
      this.$router.push({
        name: "monitor-details",
        params: { monitor_id: monitor_id },
      });
    },
  },
};
</script>
<style scoped>
.preview-title {
  font-size: 0.8vw;
  padding-bottom: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
